export default {
    GENERATE_SNACKBAR({ commit }, payload) {
        commit('SET_SNACKBAR', payload);
    },
    COMMIT_TITLE({ commit }, payload) {
        commit('SET_TITLE', payload);
    },
}